import React from 'react'

import styles from './LoadingSpinner.module.css'
import loadingAnimation from '../assets/images/loading.svg'


export default (props) => (
  <div className={styles.container}>
    <img src={loadingAnimation} />
  </div>
)



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.js